/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/undo'
export default icon
